'use client';

import { c as _c } from "react/compiler-runtime";
import { LinkList, LinkListItem } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { dataLayerPush, getBaseUrlJoined, layoutEvents, trackMainNavLinkClick } from '@libs/analytics';
import { useDeviceType } from '@libs/common-next';
import type { Link, LinkAction } from '../../types';
import { getLinkFromLinkOrLinkAction } from '../../utils/getLinkFromLinkOrLinkAction';
import { propsMapper } from '../../utils/propsMapper';
import type { SecondaryNavigationProps } from './types';
import './SecondaryNavigation.scss';
export const trackingData = (data: object) => Object.assign(data, {
  ...layoutEvents.headerClick
});
export default function SecondaryNavigation(t0) {
  const $ = _c(27);
  const {
    navigationLinks,
    tabletNavigationLinks,
    isHeader: t1,
    className
  } = t0;
  const isHeader = t1 === undefined ? true : t1;
  const t2 = isHeader ? "link-list" : "link-list link-list__drawer";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn(t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const classes = t3;
  const t4 = !isHeader;
  let t5;
  if ($[3] !== isHeader || $[4] !== t4) {
    t5 = cn({
      "link-list--normal": isHeader,
      "link-list--big sparky-u-margin-left-md": t4
    });
    $[3] = isHeader;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const linkClasses = t5;
  const {
    isDesktop
  } = useDeviceType();
  let T0;
  let t10;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== classes || $[7] !== isDesktop || $[8] !== isHeader || $[9] !== linkClasses || $[10] !== navigationLinks || $[11] !== tabletNavigationLinks) {
    const links = propsMapper((isDesktop ? navigationLinks : tabletNavigationLinks) ?? []);
    const flatLinks = links.map(_temp);
    T0 = LinkList;
    t6 = "secondary-navigation";
    t7 = classes;
    t8 = isHeader ? "sm" : undefined;
    t9 = isHeader ? "horizontal" : undefined;
    let t11;
    if ($[18] !== linkClasses) {
      t11 = t12 => {
        const {
          actionText,
          webUrl,
          iconName
        } = t12;
        return <LinkListItem iconName={iconName} iconPosition="after" className={linkClasses} onClick={() => {
          trackMainNavLinkClick(actionText);
          dataLayerPush(trackingData({
            selection: actionText,
            link_url: getBaseUrlJoined(webUrl)
          }));
        }} key={webUrl} href={webUrl} text={actionText} />;
      };
      $[18] = linkClasses;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    t10 = flatLinks.map(t11);
    $[6] = classes;
    $[7] = isDesktop;
    $[8] = isHeader;
    $[9] = linkClasses;
    $[10] = navigationLinks;
    $[11] = tabletNavigationLinks;
    $[12] = T0;
    $[13] = t10;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    T0 = $[12];
    t10 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[20] !== T0 || $[21] !== t10 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t11 = <T0 data-testid={t6} className={t7} size={t8} behavior={t9}>{t10}</T0>;
    $[20] = T0;
    $[21] = t10;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}
function _temp(linkOrLinkAction) {
  return getLinkFromLinkOrLinkAction(linkOrLinkAction);
}